(function () {
  if (window.__xenithCoreAnalyticsLoaded) return;
  window.__xenithCoreAnalyticsLoaded = true;

  const pushEvent = (eventName, detail) => {
    const payload = Object.assign(
      {
        event: eventName,
        brand: 'XENITH CORE',
        timestamp: new Date().toISOString()
      },
      detail || {}
    );

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent('xenith-core:event', { detail: payload }));
  };

  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-xenith-event]');
    if (!target) return;

    const scope = target.closest('[data-xenith-scope]');
    pushEvent(target.dataset.xenithEvent, {
      scope: scope?.dataset.xenithScope || target.dataset.xenithScope || '',
      label: target.dataset.xenithLabel || target.textContent.replace(/\s+/g, ' ').trim(),
      destination: target.getAttribute('href') || '',
      product_id: target.dataset.xenithProductId || scope?.dataset.xenithProductId || '',
      product_title: target.dataset.xenithProductTitle || scope?.dataset.xenithProductTitle || ''
    });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const scope = form.closest('[data-xenith-scope]');
    const xenithFormNode = form.matches('[data-xenith-form]') ? form : form.closest('[data-xenith-form]');
    const isXenithForm = Boolean(xenithFormNode);
    const isCartAdd = form.action && form.action.includes('/cart/add') && scope;
    if (!isXenithForm && !isCartAdd) return;

    pushEvent(isXenithForm ? xenithFormNode.dataset.xenithForm : 'xenith_add_to_cart', {
      scope: scope?.dataset.xenithScope || '',
      product_id: xenithFormNode?.dataset.xenithProductId || scope?.dataset.xenithProductId || '',
      product_title: xenithFormNode?.dataset.xenithProductTitle || scope?.dataset.xenithProductTitle || '',
      form_id: form.id || ''
    });
  });
})();
